module.exports = __webpack_public_path__ + "img/rachit.9b572f49.jpg";